module.exports = __webpack_public_path__ + "static/media/DOCKER Copy.9a6a419b.png";